// Layouts
import PublicLayout from 'core/ui/layouts/PublicLayout';
// import AuthenticatedLayout from 'core/ui/layouts/AuthenticatedLayout';

// Pages
import MainPage from 'core/ui/pages/MainPage';
import JohariPage from 'johari/ui/pages/JohariPage';

export default [
  {
    component: JohariPage,
    layout: PublicLayout,
    isPublic: true,
    redirectLogged: false,
    path: '/',
  },
  // {
  //   component: DashboardPage,
  //   layouts: AuthenticatedLayout,
  //   path: '/',
  //   exact: true,
  // },
];
